export default __webpack_public_path__ + "static/media/trainings-eng.13362622.png";